import { Loader } from "@/components/loader";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getModulesInTab, getSubModuleInArea } from "../../../../api/area";
import DrugInParvande from "../../sidebarArea/drug/drugInParvande";
import Library from "../library/library";
import Referral from "../referral";
import GeneralSieve from "./generalSieve";

export default function Qarbal({
  selectedModuleTab,
  areaId,
  dataUser,
  selectedModule,
}) {
  const [dataSubModule, setDataSubModule] = useState();
  const [selectedTab, setSelectedTab] = useState();
  const [loading, setLoading] = useState(false);
  const [subModuleDataSelected, setSubModuleDataSelected] = useState();
  useEffect(() => {
    if (
      areaId &&
      selectedModuleTab &&
      selectedModuleTab !== null &&
      selectedModuleTab !== "null"
    ) {
      getModulesInTab(areaId, selectedModuleTab)
        .then((x) => {
          setDataSubModule(x);
          setSelectedTab(x.find((e) => e.moduleId === selectedModule));
        })
        .catch(() => {});
    }
  }, [areaId, selectedModuleTab]);
  useEffect(() => {
    if (selectedTab) {
      setLoading(true);
      getSubModuleInArea(areaId, selectedTab?.moduleId)
        .then((x) => {
          setSubModuleDataSelected(x);
          setLoading(false);
        })
        .catch(() => {});
    }
  }, [selectedTab]);

  return (
    <Box
      height={"80vh"}
      sx={{
        overflow: "auto",
        "::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <Box display="flex" gap="20px">
        {dataSubModule?.map((x, i) => (
          <Typography
            key={i}
            onClick={() => {
              setSelectedTab(x);
            }}
            sx={{ cursor: "pointer" }}
            mt="20px"
            fontWeight="bold"
            color={
              selectedTab?.moduleName === x.moduleName
                ? "var(--emr-darkblue)"
                : "var(--emr-disable)"
            }
          >
            {x.moduleName}
          </Typography>
        ))}
      </Box>

      {loading && <Loader />}

      {!loading && (
        <>
          {subModuleDataSelected?.subModules?.map((x, index) => (
            <Box key={index}>
              <GeneralSieve
                areaId={areaId}
                data={x}
                moduleId={selectedTab?.moduleId}
              />
            </Box>
          ))}
          {subModuleDataSelected?.isReferral && (
            <Referral
              fromModuleId={subModuleDataSelected?.id}
              data={dataUser}
            />
          )}
          {subModuleDataSelected?.canSuggestExperiment && (
            <Library areaId={areaId} moduleId={selectedTab?.moduleId} />
          )}
          {subModuleDataSelected?.canSuggestDrug && (
            <DrugInParvande areaId={areaId} moduleId={selectedTab?.moduleId} />
          )}
        </>
      )}
    </Box>
  );
}
